import { AfterContentChecked, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { fromEvent, Observable, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
//import { validateHorizontalPosition } from '@angular/cdk/overlay';

@Component({
	selector: 'cass-card-slider',
	templateUrl: './card-slider.component.html',
	styleUrls: ['./card-slider.component.css']
})
export class CardSliderComponent implements OnInit, OnDestroy, AfterContentChecked {

	sliderLeftMargin: number = 0;
	minMargin: number = 0;
	movement: number = 0;
	viewportWidth: number = 0;

	@ViewChild('sliderContentsWrapper')
	sliderContentsWrapper?: ElementRef;

	@ViewChild('sliderViewport')
	sliderViewport?: ElementRef;

	private resizeObservable$: Observable<Event> | undefined;
	private resizeSubscription$: Subscription | undefined;

	constructor() { }

	ngOnInit() {
		this.resizeObservable$ = fromEvent(window, 'resize');
		this.resizeSubscription$ = this.resizeObservable$.pipe(debounceTime(1000)).subscribe(evt => {
			this.refreshMeasures();
		});
	}

	ngOnDestroy() {
		this.resizeSubscription$?.unsubscribe();
	}

	ngAfterContentChecked(): void {
		if (this.viewportWidth !== this.sliderViewport?.nativeElement?.clientWidth) {
			this.refreshMeasures();
		}
	}

	refreshMeasures(): void {
		let viewportWidth = this.sliderViewport?.nativeElement?.clientWidth;
		this.minMargin = viewportWidth - this.sliderContentsWrapper?.nativeElement?.scrollWidth;
		this.movement = viewportWidth * 0.6;
	}

	leftButton() {
		// TODO want to move in multiple of item widths
		this.sliderLeftMargin = Math.min(0, this.sliderLeftMargin + this.movement);
	}

	rightButton() {
		// TODO want to move in multiple of item widths
		this.sliderLeftMargin = Math.max(this.minMargin, this.sliderLeftMargin - this.movement);
	}
}
